import React from 'react';
import styled from 'styled-components';
import { ItemProperty } from './CommonStyles';

interface ICartItemQuantity {
  quantity: number;
  quantityLabel: string;
}

const CartItemQuantityWrapper = styled(ItemProperty)`
`;

const CartItemQuantity = ({ quantity, quantityLabel }: ICartItemQuantity): JSX.Element => (
  <CartItemQuantityWrapper className="cart-item-quantity">
    {quantityLabel}:&nbsp;
    <span data-test-id="dp_product_quantity">
      {quantity}
    </span>
  </CartItemQuantityWrapper>
);

export default CartItemQuantity;
